import { Button } from '@mantine/core';
import { FaCopy } from 'react-icons/fa';

interface CloneRecordsButtonProps {
  disabled?: boolean;
  onClick: () => void;
}

export const CloneRecordsButton = ({ disabled = false, onClick }: CloneRecordsButtonProps) => {
  return (
    <Button
      variant="outline"
      leftSection={<FaCopy size={16} />}
      disabled={disabled}
      onClick={onClick}
    >
      Clone
    </Button>
  );
};